<template>
  <InfoBanner type="neutral">
    <template #title>
      <div class="banner-title">
        {{ stubInfo.title }}
      </div>
    </template>
  </InfoBanner>
  <CommonButton @click="redirectToSign" spaced>
    {{ stubInfo.button_text }}
  </CommonButton>
</template>

<script>
import InfoBanner from "@/components/shared/banner/InfoBanner";
import CommonButton from "@/components/shared/button/CommonButton";

export default {
  components: {
    InfoBanner,
    CommonButton,
  },
  props: {
    stubInfo: {
      type: Object,
      required: true,
    },
  },
  beforeRouteLeave() {
    this.$store.dispatch("system/setLoaderStatus", false);
  },
  methods: {
    redirectToSign() {
      this.$store.dispatch("system/setLoaderStatus", true);
      window.location.href = this.stubInfo.button_link;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner-title {
  margin: 5px 0;
  color: #4a4a4a;
}
</style>
